import { AdminTypeV2 } from '@doc-abode/data-models';
import { findByValue } from '../common/findByValue';
import { getFriendlyLabel, getFriendlyLabelFromArray } from '../common/getFriendlyLabel';

export function findAdminType(
    adminToFind?: string,
    adminTypes?: AdminTypeV2[],
): AdminTypeV2 | undefined {
    return findByValue(adminToFind, adminTypes) as AdminTypeV2 | undefined;
}

export function getFriendlyAdminTypeLabelFromAdminType(
    adminType?: AdminTypeV2,
    textIfNotFound?: string,
): string {
    return getFriendlyLabel(adminType, textIfNotFound);
}

export function getFriendlyAdminTypeLabel(
    adminToFind?: string,
    adminTypes?: AdminTypeV2[],
    textIfNotFound?: string,
): string {
    return getFriendlyLabelFromArray(adminToFind, adminTypes, textIfNotFound);
}
